<template>
    <div :class="tabletMode ? 'container-fluid' : 'container'" class="nopadding">
        <div id="trs-content">
            <div class="row">
                <div class="col-lg-2 left-menu">
                    <LeftMenu/>
                </div>
                <div class="col-lg-10 content">
                    <div class="page">
                        <router-view></router-view>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/**
 * @author HungNS
 */
import LeftMenu from "../../components/common/app/LeftMenu";
import {createNamespacedHelpers} from "vuex";
import * as NEWS_TYPE from "@/store/modules/news/type";
import EventBus from "@/services/EventBus";

const {mapActions: mapNewsActions} = createNamespacedHelpers("news");

export default {
    name: "Home",
    components: {
        LeftMenu,
    },
    methods: {
        ...mapNewsActions([NEWS_TYPE.FORCE_SET_AGREE_FLG])
    },
    created() {
        EventBus.$emit('newsFetched', true);
        this[NEWS_TYPE.FORCE_SET_AGREE_FLG](false)
    }
};
</script>
<style scoped>
.container {
    max-width: 1170px;
}

@media screen and (min-width: 980px) {
    .left-menu {
        width: 20%;
    }
    .content {
        width: 80%;
    }
}
</style>
